import React from "react";
import { ElementsConsumer, CardElement, injectStripe } from "@stripe/react-stripe-js";
import CardSection from "../account/CardSection";
import ReactToolTip from 'react-tooltip';

import './signup.css';
import Footer from '../common/footer/footer';
import Header from './../common/header/header';
import $ from 'jquery';
import Validate from '../common/validate';
import Axios from 'axios';
import { API_HOST, axiosRequest } from './../../constants/server.constant';
import { Redirect } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import ReactTooltip from 'react-tooltip';
import CommonMessage from './../common/commonMessage';
import SessionService from '../../services/session.service';
import { loadStripe } from "@stripe/stripe-js";
import { loginService } from "../../services/login.service";
import { userService } from "../../services/user.service";

class CheckoutFormSignup extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            signupForm: {
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                companyName: '',
                countryCode: '+1',
                phoneNumber: '',
                billingAddress: '',
                zipCode: '',
                cardDetails: {
                    cardNumber: '',
                    expiryMonth: '',
                    expiryYear: '',
                    cvc: '',
                },
                isAgreed: false,
            },
            userid: "",
            authToken: "",
            hidePwd: true,
            isPwdShown: false,
            errors: {},
            loading: true,
            pwdstrength: "",
            firstNameEmpty: false,
            lastNameEmpty: false,
            emailEmpty: false,
            userNameEmpty: false,
            passwordEmpty: false,
            phoneNumberEmpty: false,
            billingAddressEmpty: false,
            zipCodeEmpty: false,
            checkboxstatus: false,
            userNameExists: false,
            isAction: false,
            stripePromise: loadStripe("pk_test_51I71o3KD8YUugTD1p18N7Kpq3RbEB05nTMGXkDTSQQYDMLcta9gO1rHGjIchv2qEF43QX0XnxC3mKZ01SgoJubO100F6VmFPbB"),
            stripeObj: {},
            redirect: false,
            redirectFirstName: "",
            redirectEmail: "",
            firstNameRegex: false,
            lastNameRegex: false,
            emailRegex: false,
            userNameRegex: false,
            passwordRegex: false,
            phoneNumberRegex: false,
            zipCodeRegex: false,
            redirect: "/login",
        };
        this.formChangeHandler = this.formChangeHandler.bind(this);
        this.handlesubmit = this.handlesubmit.bind(this);
        this.validate = this.validate.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.recaptchaRef = React.createRef();
        this.firstNameInput = React.createRef();
        this.lastNameInput = React.createRef();
        this.emailInput = React.createRef();
        this.userNameInput = React.createRef();
        this.passwordInput = React.createRef();
        this.countryCodeInput = React.createRef();
        this.phoneNumberInput = React.createRef();
        this.billingAddressInput = React.createRef();
        this.zipCodeInput = React.createRef();
        this.inputFocus = this.inputFocus.bind(this);
        this.handleStripeSubmit = this.handleStripeSubmit.bind(this);

    }

    handleStripeSubmit = async event => {
        const { stripe, elements } = this.props;
        if(!stripe || !elements) {
            return;
        }
        const card = elements.getElement(CardElement);
        const result = await stripe.createToken(card, { address_line1: this.state.billingAddress, address_zip: this.state.zipCode });
        if(result.error) {
            //console.log(result.error.message);
            // this.setState({
            //   message : result.error.message,
            // })  
            var errspan = document.getElementById("ccDetailsErr");
            errspan.innerText = result.error.message;
            errspan.style.display = "block";
            setTimeout(() => {
                errspan.innerText = "";
                errspan.style.display = "block";
            }, 5000);

            return;
        } else {
            this.setState({
                stripeObj: result.token,
            });

            if(!(this.state.signupForm.isAgreed)) {
                setTimeout(() => {
                    this.setState({
                        checkboxstatus: !this.state.checkboxstatus
                    });

                }, 10000);
                this.setState({
                    checkboxstatus: !this.state.checkboxstatus
                });
            }
            else {
                this.recaptchaRef.current.execute();
            }

        }
        //console.log(result)
        //return result;
    };

    inputFocus = (event, param) => {
        if(param === "lastname") {
            if(this.state.signupForm.firstName.length <= 0) {
                this.setState({
                    firstNameEmpty: true
                });
            }
            if(this.state.signupForm.firstName.length > 0) {

                this.setState({
                    firstNameEmpty: false
                });
                if(!Validate("firstName", this.state.signupForm.firstName)) {

                    this.setState({
                        firstNameRegex: true
                    });
                }
                else {
                    this.setState({
                        firstNameRegex: false
                    });
                }
            }
        }
        else if(param === "email") {
            if(this.state.signupForm.firstName.length <= 0) {
                this.setState({
                    firstNameEmpty: true
                }
                );
            }
            if(this.state.signupForm.lastName.length <= 0) {
                this.setState({
                    lastNameEmpty: true
                });
            }
            if(this.state.signupForm.firstName.length > 0) {

                this.setState({
                    firstNameEmpty: false
                });
                if(!Validate("firstName", this.state.signupForm.firstName)) {
                    this.setState({
                        firstNameRegex: true
                    });
                }
                else {
                    this.setState({
                        firstNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.lastName.length > 0) {
                this.setState({
                    lastNameEmpty: false
                });
                if(!Validate("lastName", this.state.signupForm.lastName)) {
                    this.setState({
                        lastNameRegex: true
                    });
                }
                else {
                    this.setState({
                        lastNameRegex: false
                    });
                }
            }
        }
        else if(param === "password") {
            if(this.state.signupForm.firstName.length <= 0) {
                this.setState({
                    firstNameEmpty: true
                });
            }
            if(this.state.signupForm.lastName.length <= 0) {
                this.setState({
                    lastNameEmpty: true
                });
            }
            if(this.state.signupForm.email.length <= 0) {
                this.setState({
                    emailEmpty: true
                });
            }

            if(this.state.signupForm.firstName.length > 0) {
                this.setState({
                    firstNameEmpty: false
                });
                if(!Validate("firstName", this.state.signupForm.firstName)) {
                    this.setState({
                        firstNameRegex: true
                    });
                }
                else {
                    this.setState({
                        firstNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.lastName.length > 0) {
                this.setState({
                    lastNameEmpty: false
                });
                if(!Validate("lastName", this.state.signupForm.lastName)) {
                    this.setState({
                        lastNameRegex: true
                    });
                }
                else {
                    this.setState({
                        lastNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.email.length > 0) {
                this.setState({
                    emailEmpty: false
                });
                if(!Validate("email", this.state.signupForm.email)) {
                    this.setState({
                        emailRegex: true
                    });
                }
                else {
                    this.setState({
                        emailRegex: false
                    });
                }
            }

        }
        else if(param === "company") {
            if(this.state.signupForm.firstName.length <= 0) {

                this.setState({
                    firstNameEmpty: true
                });
            }
            if(this.state.signupForm.lastName.length <= 0) {

                this.setState({
                    lastNameEmpty: true
                });
            }
            if(this.state.signupForm.email.length <= 0) {

                this.setState({
                    emailEmpty: true
                });
            }

            if(this.state.signupForm.password.length <= 0) {

                this.setState({
                    passwordEmpty: true
                });
            }
            if(this.state.signupForm.firstName.length > 0) {
                this.setState({
                    firstNameEmpty: false
                });
                if(!Validate("firstName", this.state.signupForm.firstName)) {
                    this.setState({
                        firstNameRegex: true
                    });
                }
                else {
                    this.setState({
                        firstNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.lastName.length > 0) {
                this.setState({
                    lastNameEmpty: false
                });
                if(!Validate("lastName", this.state.signupForm.lastName)) {
                    this.setState({
                        lastNameRegex: true
                    });
                }
                else {
                    this.setState({
                        lastNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.email.length > 0) {
                this.setState({
                    emailEmpty: false
                });
                if(!Validate("email", this.state.signupForm.email)) {
                    this.setState({
                        emailRegex: true
                    });
                }
                else {
                    this.setState({
                        emailRegex: false
                    });
                }
            }

            if(this.state.signupForm.password.length > 0) {
                this.setState({
                    passwordEmpty: false
                });

                if(!Validate("password", this.state.signupForm.password)) {
                    this.setState({
                        passwordRegex: true
                    });
                }
                else {
                    this.setState({
                        passwordRegex: false
                    });
                }
            }

        }
        else if(param === "country" || param === "phone") {
            if(this.state.signupForm.firstName.length <= 0) {

                this.setState({
                    firstNameEmpty: true
                });
            }
            if(this.state.signupForm.lastName.length <= 0) {

                this.setState({
                    lastNameEmpty: true
                });
            }
            if(this.state.signupForm.email.length <= 0) {

                this.setState({
                    emailEmpty: true
                });
            }

            if(this.state.signupForm.password.length <= 0) {

                this.setState({
                    passwordEmpty: true
                });
            }
            if(this.state.signupForm.firstName.length > 0) {
                this.setState({
                    firstNameEmpty: false
                });
            }
            if(this.state.signupForm.firstName.length > 0) {
                this.setState({
                    firstNameEmpty: false
                });
                if(!Validate("firstName", this.state.signupForm.firstName)) {
                    this.setState({
                        firstNameRegex: true
                    });
                }
                else {
                    this.setState({
                        firstNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.lastName.length > 0) {
                this.setState({
                    lastNameEmpty: false
                });
                if(!Validate("lastName", this.state.signupForm.lastName)) {
                    this.setState({
                        lastNameRegex: true
                    });
                }
                else {
                    this.setState({
                        lastNameRegex: false
                    });
                }
            }
            if(this.state.signupForm.email.length > 0) {
                this.setState({
                    emailEmpty: false
                });
                if(!Validate("email", this.state.signupForm.email)) {
                    this.setState({
                        emailRegex: true
                    });
                }
                else {
                    this.setState({
                        emailRegex: false
                    });
                }
            }

            if(this.state.signupForm.password.length > 0) {
                this.setState({
                    passwordEmpty: false
                });
                if(!Validate("password", this.state.signupForm.password)) {
                    this.setState({
                        passwordRegex: true
                    });
                }
                else {
                    this.setState({
                        passwordRegex: false
                    });
                }
            }

        }

    };
    formChangeHandler = (event) => {

        let name = event.target.name;
        let val = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.state.signupForm[name] = val;
        if(name === "firstName") {
            if(val.length > 0) {
                this.setState({
                    firstNameEmpty: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    firstNameEmpty: true,
                    firstNameRegex: false
                });
            }
        }
        if(name === "lastName") {
            if(val.length > 0) {
                this.setState({
                    lastNameEmpty: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    lastNameEmpty: true,
                    lastNameRegex: false
                });
            }
        }
        if(name === "email") {
            if(val.length > 0) {
                this.setState({
                    emailEmpty: false,
                    userNameExists: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    emailEmpty: true,
                    emailRegex: false,
                    userNameExists: false
                });
            }
        }

        if(name === "password") {

            const strongPwd = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-_!@#\$%\^&\*])(?=\\S+$)(?=.{8,})");

            if(val.length > 0) {
                if(strongPwd.test(val)) {
                    this.setState({
                        pwdstrength: "strong"
                    });
                }
                else {
                    this.setState({
                        pwdstrength: "weak"
                    });
                }
                this.setState({
                    passwordEmpty: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    passwordEmpty: true,
                    pwdstrength: "",
                    passwordRegex: false
                });
            }


        }
        if(name === "phoneNumber") {

            if(val.length > 0) {

                this.setState({
                    phoneNumberEmpty: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    phoneNumberEmpty: true,
                    phoneNumberRegex: false
                });
            }
        }
        if(val !== undefined && val !== '') {
            this.state.errors[name] = false;
        }

        if(name == "billingAddress") {
            if(val.length > 0) {
                this.setState({
                    billingAddressEmpty: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    billingAddressEmpty: true,

                });
            }
        }

        if(name == "zipCode") {
            if(val.length > 0) {
                this.setState({
                    zipCodeEmpty: false
                });
            }
            else if(val.length <= 0) {
                this.setState({
                    zipCodeEmpty: true
                });
            }
        }

        this.setState({
            signupForm: this.state.signupForm,
            errors: this.state.errors
        });
    };

    handleToggle(event) {
        this.setState({
            hidePwd: !this.state.hidePwd,
            isPwdShown: !this.state.isPwdShown,
        });
    }

    handlesubmit(event) {
        event.preventDefault();
        if(this.validate()) {
            this.handleStripeSubmit();
        } else {
            return false;
        }


    }

    onRecaptchaChange = (event) => {
        this.createUser();
    };

    createUser() {
        // this.handleStripeSubmit().then(result => {
        //     if (result.error) {
        //         console.log(result.error.message);
        //         this.setState({
        //             message : "Error while fetching Details, try again!",
        //             isAction:false
        //         })
        //     } else {
        //         console.log(result.token);

        //     }
        //    }).catch(err =>{
        //        console.log(err)
        //        this.setState({
        //             message : "Error while fetching Details, try again!",
        //             isAction:false
        //         })
        //    }) ;



        this.setState({
            isAction: true
        });

        const data = {
            companyName: this.state.signupForm.companyName,
            countryCode: this.state.signupForm.countryCode,
            email: this.state.signupForm.email,
            firstName: this.state.signupForm.firstName,
            lastName: this.state.signupForm.lastName,
            password: this.state.signupForm.password,
            phone: this.state.signupForm.phoneNumber,

        };
        const history = this.props.history;
        Axios.post(API_HOST + '/user/',
            JSON.stringify({
                companyName: data.companyName,
                countryCode: data.countryCode,
                email: data.email,
                firstName: data.firstName,
                lastName: data.lastName,
                password: data.password,
                phone: data.phone,
                status: 'Y',
                stripeObj: JSON.stringify({ "token": this.state.stripeObj, "billingAddress": this.state.signupForm.billingAddress, "zipcode": this.state.signupForm.zipCode })
            })
            , axiosRequest).then(
                (response) => {

                    //console.log(response);
                    if(response.data.error) {
                        this.setState({
                            userNameExists: true,
                            isAction: false
                        });
                        this.emailInput.current.focus();
                        if(this.recaptchaRef.current) {
                            this.recaptchaRef.current.reset();
                        }
                        return;
                    }
                    if(response.status === 201) {
                        loginService.autoAuthenticate(JSON.stringify({ email: data.email, password: data.password, rememberMe: false })).then(authResp => {
                            if(!authResp.data?.error) {
                                userService.getUser().then(response => {
                                    loginService.setUserLocal(response, true);
                                    this.setState({ redirect: authResp.data?.redirect });
                                }).catch(error => {
                                    this.setState({
                                        wrongcreds: true,
                                        errmsg: "Error While trying to connect",
                                        isAction: false
                                    });
                                    if(this.recaptchaRef.current) {
                                        this.recaptchaRef.current.reset();
                                    }
                                });
                            }
                            else {
                                this.setState({
                                    wrongcreds: true,
                                    errmsg: "Error while fetching Details, try again!",
                                    isAction: false
                                });
                                if(this.recaptchaRef.current) {
                                    this.recaptchaRef.current.reset();
                                }
                            }
                        }).catch((err) => {
                            this.setState({
                                message: "Error while fetching Details, try again!",
                                isAction: false
                            });
                            if(this.recaptchaRef.current) {
                                this.recaptchaRef.current.reset();
                            }
                            return;
                        });
                    }
                    else {
                        this.setState({
                            message: "Error while fetching Details, try again!",
                            isAction: false
                        });
                        if(this.recaptchaRef.current) {
                            this.recaptchaRef.current.reset();
                        }

                    }
                }
            ).catch((error) => {
                this.setState({
                    message: error.response.data,
                    isAction: false
                });
                if(this.recaptchaRef.current) {
                    this.recaptchaRef.current.reset();
                }
            });
    }

    validate() {
        if(this.state.signupForm.firstName.length <= 0) {
            this.setState({
                firstNameEmpty: true
            });
            this.firstNameInput.current.focus();
            return false;
        }
        else if(this.state.signupForm.lastName.length <= 0) {
            this.setState({
                lastNameEmpty: true
            });
            this.lastNameInput.current.focus();
            return false;
        }
        else if(this.state.signupForm.email.length <= 0) {
            this.setState({
                emailEmpty: true
            });
            this.emailInput.current.focus();
            return false;
        }

        else if(this.state.signupForm.password.length <= 0) {
            this.setState({
                passwordEmpty: true,

            });
            this.passwordInput.current.focus();
            return false;
        }
        else if(this.state.signupForm.phoneNumber.length <= 0) {
            this.setState({
                phoneNumberEmpty: true
            });
            this.phoneNumberInput.current.focus();
            return false;
        } else if(this.state.signupForm.billingAddress.length <= 0) {
            this.setState({
                billingAddressEmpty: true
            });
            this.billingAddressInput.current.focus();
            return false;
        } else if(this.state.signupForm.zipCode.length <= 0) {
            this.setState({
                zipCodeEmpty: true
            });
            this.zipCodeInput.current.focus();
            return false;
        }
        else {

            if(!Validate("firstName", this.state.signupForm.firstName)) {
                this.setState({
                    firstNameRegex: true
                });
                this.firstNameInput.current.focus();
                return false;

            }
            else if(!Validate("lastName", this.state.signupForm.lastName)) {
                this.setState({
                    lastNameRegex: true
                });
                this.lastNameInput.current.focus();
                return false;

            }
            else if(!Validate("email", this.state.signupForm.email)) {
                this.setState({
                    emailRegex: true
                });
                this.emailInput.current.focus();
                return false;
            }

            else if(!Validate("password", this.state.signupForm.password)) {
                this.setState({
                    passwordRegex: true
                });
                this.passwordInput.current.focus();
                return false;
            } else if(!Validate("phoneNumber", this.state.signupForm.phoneNumber)) {
                this.setState({
                    phoneNumberRegex: true
                });
                this.phoneNumberInput.current.focus();
                return false;
            } else if(Validate("zipCode", this.state.signupForm.zipCode)) {
                this.setState({
                    zipCodeRegex: true
                });
                this.zipCodeInput.current.focus();
                return false;
            } else {
                return true;
            }

        }


    }

    componentDidMount() {
        // if(!sessionStorage.signupLoaded) {
        //     asyncCall().then(() => this.setState({ loading: false }));
        // }
        document.title = "IDrive® Compute | Sign-up page";
        // const link1 = document.createElement("link")
        // link1.href = "https://www.idrivecompute.com/webapp/css/signup.css"
        // link1.rel = "stylesheet"
        // document.head.appendChild(link1)
        // var link = $("<link>");
        // link.attr({
        //     rel: 'stylesheet',
        //     href: "https://www.idrivecompute.com/webapp/css/static-common.css",
        // });

        // $("head").append(link);

    }

    render() {

        // const loading = this.state.loading;
        // if (!sessionStorage.signupLoaded && loading) {
        //     return null;
        // }
        sessionStorage.signupLoaded = true;
        if(SessionService.getCookie("isLoggedIn")) {
            return <Redirect to={ this.state.redirect } replace={ true }></Redirect>;
        }
        return (
            <React.Fragment>
                <Header />
                <div className="signup_ui">
                    <div className="static">
                        <div className="signup_container">
                            <div className="signup_bg"></div>
                            <div className="container">
                                <div className="signup_content_wrap clearfix">
                                    <section className="signup_lhs">
                                        <h2>Create My Account</h2>
                                        <form onSubmit={ this.handlesubmit }>
                                            <div className="inp_primary_box">
                                                <div className="inp_row clearfix">
                                                    <div className="inp_col_lhs">
                                                        <label>First Name</label>
                                                        <input type="text" maxLength="20" ref={ this.firstNameInput } id="firstName" autoFocus name="firstName" value={ this.state.signupForm.firstName } onChange={ this.formChangeHandler } className="txt_box" />
                                                        <span className="err_msg" id="firstNameErr" style={ { display: this.state.firstNameEmpty ? 'inline-block' : 'none' } } >First name cannot be blank</span>
                                                        <span className="err_msg" style={ { display: (this.state.errors["firstName"] !== undefined && this.state.errors["firstName"]) ? 'inline-block' : 'none' } } >First name can contain a-z, A-Z and space </span>
                                                        <span className="err_msg" style={ { display: this.state.firstNameRegex ? 'inline-block' : 'none' } } >First name can contain a-z, A-Z and space </span> </div>
                                                    <div className="inp_col_rhs">
                                                        <label>Last Name</label>
                                                        <input type="text" maxLength="20" id="lastName" ref={ this.lastNameInput } name="lastName" value={ this.state.signupForm.lastName } onChange={ this.formChangeHandler } onFocus={ (e) => this.inputFocus(e, "lastname") } onClick={ (e) => this.inputFocus(e, "lastname") } className="txt_box" />
                                                        <span className="err_msg" id="lastNameErr" style={ { display: this.state.lastNameEmpty ? 'inline-block' : 'none' } } >Last name cannot be blank</span>
                                                        <span className="err_msg" style={ { display: (this.state.errors["lastName"] !== undefined && this.state.errors["lastName"]) ? 'inline-block' : 'none' } }>Last name can contain a-z, A-Z and space</span>
                                                        <span className="err_msg" style={ { display: this.state.lastNameRegex ? 'inline-block' : 'none' } } >Last name can contain a-z, A-Z and space </span>
                                                    </div>
                                                </div>
                                                <div className="inp_row clearfix">
                                                    <div className="inp_col_lhs">
                                                        <label>Email Address</label>
                                                        <input type="text" ref={ this.emailInput } id="email" name="email" value={ this.state.signupForm.email } onChange={ this.formChangeHandler } onFocus={ (e) => this.inputFocus(e, "email") } onClick={ (e) => this.inputFocus(e, "email") } className="txt_box" />
                                                        <span className="err_msg" id="emailErr" style={ { display: this.state.emailEmpty ? 'inline-block' : 'none' } } >Email cannot be blank</span>
                                                        <span className="err_msg" style={ { display: (this.state.errors["email"] !== undefined && this.state.errors["email"]) ? 'inline-block' : 'none' } }>Email address is Invalid</span>
                                                        <span className="err_msg" style={ { display: this.state.emailRegex ? 'inline-block' : 'none' } }>Email address is Invalid</span>
                                                        <span className="err_msg" style={ { display: this.state.userNameExists ? 'inline-block' : 'none' } } >Email already in use. Enter a different email.</span>
                                                    </div>
                                                    <div className="inp_col_lhs">
                                                        <label>
                                                            Create Password
                                                            { this.state.pwdstrength === "weak" ? <div className="pwd_strength weak">Weak</div> : this.state.pwdstrength === "strong" ? <div className="pwd_strength strong" >Strong</div> : "" }

                                                        </label>
                                                        <div className="inp_icon_wrap pwd_field_wrap">
                                                            <input type={ this.state.hidePwd ? "password" : "text" } id="password" ref={ this.passwordInput } name="password" value={ this.state.password } onChange={ this.formChangeHandler } onClick={ (e) => this.inputFocus(e, "password") } onFocus={ (e) => this.inputFocus(e, "password") } className="txt_box" />
                                                            <div class="id-tooltip id-tooltip-topright">
                                                                <p class="id-tooltip-note">Use atleast:</p>
                                                                <ul>
                                                                    <li>1 uppercase character</li>
                                                                    <li>1 lowercase character</li>
                                                                    <li>1 numerical digit</li>
                                                                    <li>1 special character</li>
                                                                    <li>Min 8 characters </li>
                                                                </ul>
                                                            </div>
                                                            <span className={ this.state.isPwdShown ? "pwd_field_eyeIcon show_pwd" : "pwd_field_eyeIcon" } data-tip data-for="password" onClick={ this.handleToggle }></span>
                                                        </div><ReactTooltip id="password" place="bottom" effect="solid">
                                                            { this.state.isPwdShown ? "Hide" : "Show" }
                                                        </ReactTooltip>
                                                        <span className="err_msg" id="passwordErr" style={ { display: this.state.passwordEmpty ? 'inline-block' : 'none' } } >Password cannot be blank</span>
                                                        <span className="err_msg" style={ { display: (this.state.errors["password"] !== undefined && this.state.errors["password"]) ? 'inline-block' : 'none' } }>Password  should be of minimum 8 characters and must contain atleast 1 uppercase alphabet, 1 lowercase alphabet, 1 numerical digit, and 1 special character </span>
                                                        <span className="err_msg" style={ { display: this.state.passwordRegex ? 'inline-block' : 'none' } }>Password is invalid</span>
                                                    </div>

                                                </div>
                                                <div className="inp_row clearfix">


                                                    <label>Company Name (Optional)</label>
                                                    <input type="text" name="companyName" value={ this.state.signupForm.companyName } onChange={ this.formChangeHandler } onClick={ (e) => this.inputFocus(e, "company") } onFocus={ (e) => this.inputFocus(e, "company") } className="txt_box" />
                                                    <span className="err_msg" style={ { display: (this.state.errors["companyName"] !== undefined && this.state.errors["companyName"]) ? 'inline-block' : 'none' } }>Invalid input</span>
                                                </div>
                                                <div className="inp_row clearfix">
                                                    <div className="inp_col_lhs">
                                                        <label>Country Code</label>
                                                        <div className="custom_select_box coutry_code_wrap">
                                                            <select name="countryCode" value={ this.state.signupForm.countryCode } onChange={ this.formChangeHandler } onClick={ (e) => this.inputFocus(e, "country") } onFocus={ (e) => this.inputFocus(e, "country") }  >
                                                                <option value="USA">USA +1</option>
                                                                <option value="Afghanistan">Afghanistan +93 </option>
                                                                <option value="Albania">Albania +355 </option>
                                                                <option value="Algeria">Algeria +213 </option>
                                                                <option value="American Samoa">American Samoa +684 </option>
                                                                <option value="Andorra">Andorra +376 </option>
                                                                <option value="Angola">Angola +244 </option>
                                                                <option value="Anguilla">Anguilla +1-264 </option>
                                                                <option value="Antarctica">Antarctica +672 </option>
                                                                <option value="Antigua and Barbuda">Antigua and Barbuda +1-268 </option>
                                                                <option value="Argentina">Argentina +54 </option>
                                                                <option value="Armenia">Armenia +374 </option>
                                                                <option value="Aruba">Aruba +297 </option>
                                                                <option value="Australia">Australia +61 </option>
                                                                <option value="Austria">Austria +43 </option>
                                                                <option value="Azerbaijan">Azerbaijan +994 </option>
                                                                <option value="Bahamas">Bahamas +1-242 </option>
                                                                <option value="Bahrain">Bahrain +973 </option>
                                                                <option value="Bangladesh">Bangladesh +880 </option>
                                                                <option value="Barbados ">Barbados +1-246 </option>
                                                                <option value="Belarus">Belarus +375 </option>
                                                                <option value="Belgium">Belgium +32 </option>
                                                                <option value="Belize">Belize +501 </option>
                                                                <option value="Benin">Benin +229 </option>
                                                                <option value="Bermuda">Bermuda +1-441 </option>
                                                                <option value="Bhutan">Bhutan +975 </option>
                                                                <option value="Bolivia">Bolivia +591 </option>
                                                                <option value="Bosnia-Herzegovina">Bosnia-Herzegovina +387 </option>
                                                                <option value="Botswana">Botswana +267 </option>
                                                                <option value="Brazil">Brazil + 55 </option>
                                                                <option value="Brunei Darussalam">Brunei Darussalam +673 </option>
                                                                <option value="Bulgaria">Bulgaria +359 </option>
                                                                <option value="Burkina Faso">Burkina Faso +226 </option>
                                                                <option value="Burundi">Burundi +257 </option>
                                                                <option value="Cambodia">Cambodia +855 </option>
                                                                <option value="Cameroon">Cameroon +237 </option>
                                                                <option value="Canada">Canada +1 </option>
                                                                <option value="Cape Verde">Cape Verde +238 </option>
                                                                <option value="Cayman Islands">Cayman Islands +1-345 </option>
                                                                <option value="Central African Republic">Central African Republic +236 </option>
                                                                <option value="Chad">Chad +235 </option>
                                                                <option value="Chile">Chile +56 </option>
                                                                <option value="China">China +86 </option>
                                                                <option value="Christmas Island">Christmas Island +61 </option>
                                                                <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands +61 </option>
                                                                <option value="Colombia">Colombia +57 </option>
                                                                <option value="Comoros">Comoros +269 </option>
                                                                <option value="Congo">Congo +242 </option>
                                                                <option value="Congo, Dem. Republic">Congo, Dem. Republic +243 </option>
                                                                <option value="Cook Islands">Cook Islands +682 </option>
                                                                <option value="Costa Rica">Costa Rica +506 </option>
                                                                <option value="Croatia">Croatia +385 </option>
                                                                <option value="Cuba">Cuba +53 </option>
                                                                <option value="Cyprus">Cyprus +357 </option>
                                                                <option value="Czech Rep.">Czech Rep. +420 </option>
                                                                <option value="Denmark">Denmark +45 </option>
                                                                <option value="Djibouti">Djibouti +253 </option>
                                                                <option value="Dominica">Dominica +1-767 </option>
                                                                <option value="Dominican Republic">Dominican Republic +809 </option>
                                                                <option value="Ecuador">Ecuador +593 </option>
                                                                <option value="Egypt">Egypt +20 </option>
                                                                <option value="El Salvador">El Salvador +503 </option>
                                                                <option value="Equatorial Guinea">Equatorial Guinea +240 </option>
                                                                <option value="Eritrea">Eritrea +291 </option>
                                                                <option value="Estonia">Estonia +372 </option>
                                                                <option value="Ethiopia">Ethiopia +251 </option>
                                                                <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas) +500 </option>
                                                                <option value="Faroe Islands">Faroe Islands +298 </option>
                                                                <option value="Fiji">Fiji +679 </option>
                                                                <option value="Finland">Finland +358 </option>
                                                                <option value="France">France +33 </option>
                                                                <option value="French Guiana">French Guiana +594 </option>
                                                                <option value="Gabon">Gabon +241 </option>
                                                                <option value="Gambia">Gambia +220 </option>
                                                                <option value="Georgia">Georgia +995 </option>
                                                                <option value="Germany">Germany +49 </option>
                                                                <option value="Ghana">Ghana +233 </option>
                                                                <option value="Gibraltar">Gibraltar +350 </option>
                                                                <option value="Great Britain">Great Britain +44 </option>
                                                                <option value="Greece">Greece +30 </option>
                                                                <option value="Greenland">Greenland +299 </option>
                                                                <option value="Grenada">Grenada +1-473 </option>
                                                                <option value="Guadeloupe (French)">Guadeloupe (French) +590 </option>
                                                                <option value="Guam (USA)">Guam (USA) +1-671 </option>
                                                                <option value="Guatemala">Guatemala +502 </option>
                                                                <option value="Guinea">Guinea +224 </option>
                                                                <option value="Guinea Bissau">Guinea Bissau +245 </option>
                                                                <option value="Guyana">Guyana +592 </option>
                                                                <option value="Haiti">Haiti +509 </option>
                                                                <option value="Honduras">Honduras +504 </option>
                                                                <option value="Hong Kong">Hong Kong +852 </option>
                                                                <option value="Hungary">Hungary +36 </option>
                                                                <option value="Iceland">Iceland +354 </option>
                                                                <option value="India">India +91 </option>
                                                                <option value="Indonesia">Indonesia +62 </option>
                                                                <option value="Iran">Iran +98 </option>
                                                                <option value="Iraq">Iraq +964 </option>
                                                                <option value="Ireland">Ireland +353 </option>
                                                                <option value="Israel">Israel +972 </option>
                                                                <option value="Italy">Italy +39 </option>
                                                                <option value="Ivory Coast">Ivory Coast +225 </option>
                                                                <option value="Jamaica">Jamaica +1-876 </option>
                                                                <option value="Japan">Japan +81 </option>
                                                                <option value="Jordan">Jordan +962 </option>
                                                                <option value="Kazakhstan">Kazakhstan +7 </option>
                                                                <option value="Kenya">Kenya +254 </option>
                                                                <option value="Kiribati">Kiribati +686 </option>
                                                                <option value="Korea-North">Korea-North +850 </option>
                                                                <option value="Korea-South">Korea-South +82 </option>
                                                                <option value="Kuwait">Kuwait +965 </option>
                                                                <option value="Kyrgyzstan">Kyrgyzstan +996 </option>
                                                                <option value="Laos">Laos +856 </option>
                                                                <option value="Latvia">Latvia +371 </option>
                                                                <option value="Lebanon">Lebanon +961 </option>
                                                                <option value="Lesotho">Lesotho +266 </option>
                                                                <option value="Liberia">Liberia +231 </option>
                                                                <option value="Libya">Libya +218 </option>
                                                                <option value="Liechtenstein">Liechtenstein +423 </option>
                                                                <option value="Lithuania">Lithuania +370 </option>
                                                                <option value="Luxembourg">Luxembourg +352 </option>
                                                                <option value="Macau">Macau +853 </option>
                                                                <option value="Macedonia">Macedonia +389 </option>
                                                                <option value="Madagascar">Madagascar +261 </option>
                                                                <option value="Malawi">Malawi +265 </option>
                                                                <option value="Malaysia">Malaysia +60 </option>
                                                                <option value="Maldives">Maldives +960 </option>
                                                                <option value="Mali">Mali +223 </option>
                                                                <option value="Malta">Malta +356 </option>
                                                                <option value="Marshall Islands">Marshall Islands +692 </option>
                                                                <option value="Martinique (French)">Martinique (French) +596 </option>
                                                                <option value="Mauritania">Mauritania +222 </option>
                                                                <option value="Mauritius">Mauritius +230 </option>
                                                                <option value="Mayotte">Mayotte +269 </option>
                                                                <option value="Mexico">Mexico +52 </option>
                                                                <option value="Micronesia">Micronesia +691 </option>
                                                                <option value="Moldova">Moldova +373 </option>
                                                                <option value="Monaco">Monaco +377 </option>
                                                                <option value="Mongolia">Mongolia +976 </option>
                                                                <option value="Montenegro">Montenegro +382 </option>
                                                                <option value="Montserrat">Montserrat +1-664 </option>
                                                                <option value="Morocco">Morocco +212 </option>
                                                                <option value="Mozambique">Mozambique +258 </option>
                                                                <option value="Myanmar">Myanmar +95 </option>
                                                                <option value="Namibia">Namibia +264 </option>
                                                                <option value="Nauru">Nauru +674 </option>
                                                                <option value="Nepal">Nepal +977 </option>
                                                                <option value="Netherlands">Netherlands +31 </option>
                                                                <option value="Netherlands Antilles">Netherlands Antilles +599 </option>
                                                                <option value="New Caledonia (French)">New Caledonia (French) +687 </option>
                                                                <option value="New Zealand">New Zealand +64 </option>
                                                                <option value="Nicaragua">Nicaragua +505 </option>
                                                                <option value="Niger">Niger +227 </option>
                                                                <option value="Nigeria">Nigeria +234 </option>
                                                                <option value="Niue">Niue +683 </option>
                                                                <option value="Norfolk Island">Norfolk Island +672 </option>
                                                                <option value="Northern Mariana Islands">Northern Mariana Islands +670 </option>
                                                                <option value="Norway">Norway +47 </option>
                                                                <option value="Oman">Oman +968 </option>
                                                                <option value="Pakistan">Pakistan +92 </option>
                                                                <option value="Palau">Palau +680 </option>
                                                                <option value="Panama">Panama +507 </option>
                                                                <option value="Papua New Guinea">Papua New Guinea +675 </option>
                                                                <option value="Paraguay">Paraguay +595 </option>
                                                                <option value="Peru">Peru +51 </option>
                                                                <option value="Philippines">Philippines +63 </option>
                                                                <option value="Poland">Poland +48 </option>
                                                                <option value="Polynesia (French)">Polynesia (French) +689 </option>
                                                                <option value="Portugal">Portugal +351 </option>
                                                                <option value="Puerto Rico">Puerto Rico +1-787 </option>
                                                                <option value="Qatar">Qatar +974 </option>
                                                                <option value="Reunion (French)">Reunion (French) +262 </option>
                                                                <option value="Romania">Romania +40 </option>
                                                                <option value="Russia">Russia +7 </option>
                                                                <option value="Rwanda">Rwanda +250 </option>
                                                                <option value="Saint Helena ">Saint Helena +290 </option>
                                                                <option value="Saint Kitts &amp; Nevis Anguilla">Saint Kitts &amp; Nevis Anguilla +1-869 </option>
                                                                <option value="Saint Lucia">Saint Lucia +1-758 </option>
                                                                <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon +508 </option>
                                                                <option value="Saint Vincent &amp; Grenadines">Saint Vincent &amp; Grenadines +1-784 </option>
                                                                <option value="Samoa">Samoa +684 </option>
                                                                <option value="San Marino">San Marino +378 </option>
                                                                <option value="Sao Tome and Principe">Sao Tome and Principe +239 </option>
                                                                <option value="Saudi Arabia">Saudi Arabia +966 </option>
                                                                <option value="Senegal">Senegal +221 </option>
                                                                <option value="Serbia">Serbia +381 </option>
                                                                <option value="Seychelles">Seychelles +248 </option>
                                                                <option value="Sierra Leone">Sierra Leone +232 </option>
                                                                <option value="Singapore">Singapore +65 </option>
                                                                <option value="Slovakia">Slovakia +421 </option>
                                                                <option value="Slovenia">Slovenia +386 </option>
                                                                <option value="Solomon Islands">Solomon Islands +677 </option>
                                                                <option value="Somalia">Somalia +252 </option>
                                                                <option value="South Africa">South Africa +27 </option>
                                                                <option value="Spain">Spain +34 </option>
                                                                <option value="Sri Lanka">Sri Lanka +94 </option>
                                                                <option value="Sudan">Sudan +249 </option>
                                                                <option value="Suriname">Suriname +597 </option>
                                                                <option value="Swaziland">Swaziland +268 </option>
                                                                <option value="Sweden">Sweden +46 </option>
                                                                <option value="Switzerland">Switzerland +41 </option>
                                                                <option value="Syria">Syria +963 </option>
                                                                <option value="Taiwan">Taiwan +886 </option>
                                                                <option value="Tajikistan">Tajikistan +992 </option>
                                                                <option value="Tanzania">Tanzania +255 </option>
                                                                <option value="Thailand">Thailand +66 </option>
                                                                <option value="Togo">Togo +228 </option>
                                                                <option value="Tokelau">Tokelau +690 </option>
                                                                <option value="Tonga">Tonga +676 </option>
                                                                <option value="Trinidad and Tobago">Trinidad and Tobago +1-868 </option>
                                                                <option value="Tunisia">Tunisia +216 </option>
                                                                <option value="Turkey">Turkey +90 </option>
                                                                <option value="Turkmenistan">Turkmenistan +993 </option>
                                                                <option value="Turks and Caicos Islands">Turks and Caicos Islands +1-649 </option>
                                                                <option value="Tuvalu">Tuvalu +688 </option>
                                                                <option value="U.K.">U.K. +44 </option>
                                                                <option value="Uganda">Uganda +256 </option>
                                                                <option value="Ukraine">Ukraine +380 </option>
                                                                <option value="United Arab Emirates">United Arab Emirates +971 </option>
                                                                <option value="Uruguay">Uruguay +598 </option>
                                                                <option value="USA">USA +1</option>
                                                                <option value="Uzbekistan">Uzbekistan +998 </option>
                                                                <option value="Vanuatu">Vanuatu +678 </option>
                                                                <option value="Vatican">Vatican +39 </option>
                                                                <option value="Venezuela">Venezuela +58 </option>
                                                                <option value="Vietnam">Vietnam +84 </option>
                                                                <option value="Virgin Islands (British)">Virgin Islands (British) +1-28484 </option>
                                                                <option value="Virgin Islands (USA)">Virgin Islands (USA) +1-34040 </option>
                                                                <option value="Wallis and Futuna Islands">Wallis and Futuna Islands +681 </option>
                                                                <option value="Yemen">Yemen +967 </option>
                                                                <option value="Zambia">Zambia +260 </option>
                                                                <option value="Zimbabwe">Zimbabwe +263 </option>
                                                            </select>
                                                        </div>
                                                        <span className="err_msg">Invalid input</span> </div>
                                                    <div className="inp_col_rhs">
                                                        <label>Phone Number</label>
                                                        <input type="text" id="phone" maxLength="20" ref={ this.phoneNumberInput } name="phoneNumber" value={ this.state.signupForm.phoneNumber } onChange={ this.formChangeHandler } onClick={ (e) => this.inputFocus(e, "phone") } onFocus={ (e) => this.inputFocus(e, "phone") } className="txt_box" />
                                                        <div class="id-tooltip id-tooltip-topright">
                                                            <p class="id-tooltip-note">Use atleast:</p>
                                                            <ul>
                                                                <li>minimum of 7 characters </li>
                                                                <li>maximum of 20 characters</li>
                                                                <li>only characters 0-9 x X - + ()</li>
                                                            </ul>
                                                        </div>

                                                        <span className="err_msg" id="phoneErr" style={ { display: this.state.phoneNumberEmpty ? 'inline-block' : 'none' } } >Phone number cannot be blank</span>
                                                        <span className="err_msg" style={ { display: (this.state.errors["phoneNumber"] !== undefined && this.state.errors["phoneNumber"]) ? 'inline-block' : 'none' } }> Phone number can contain only characters 0-9 x X - + () </span>
                                                        <span className="err_msg" style={ { display: this.state.phoneNumberRegex ? 'inline-block' : 'none' } }> Phone number is invalid</span>
                                                    </div>

                                                </div>
                                                <p className="form_note">Your phone number may help us reach out to you for service-related notifications.</p>
                                            </div>
                                            <div className="inp_billing_container">
                                                <h3>Billing Information</h3>
                                                {/* <div className="pay_option_wrap">
                                                    <div className="payOption_radio_wrap">
                                                        <label className="custom_radio allCard">
                                                            <input type="radio" checked="checked" name="payment_options"/>
                                                            <span className="icon_img"></span>
                                                        </label>
                                                        <label className="custom_radio payPal">
                                                            <input type="radio" name="payment_options" />
                                                            <span className="icon_img"></span>
                                                        </label>
                                                    </div>
                                                </div> */}
                                                <div className="inp_billing_box" >
                                                    <div className="inp_row card_detail_field clearfix">
                                                        <label>Card Number, expiry date and CVC
                                                            <span className="svg_wrap" data-tip data-for="cvc">
                                                                <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                                    <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                                </svg>
                                                            </span>
                                                            <ReactToolTip id="cvc" place="top" multiline={ true } effect="solid">
                                                                For Visa, MasterCard, and Discover cards,<br></br> the CVV is the last 3 digit number located on the back of your card <br></br> on or above your signature line. For an American Express card,<br></br> it is the 4 digits on the FRONT above the end of your card number.
                                                            </ReactToolTip>
                                                        </label>
                                                        <CardSection />
                                                        <p class="form_note">An amount of $1.00 will be charged and placed in temporary hold for validating your card. The amount will be refunded post verification. After that, you will be charged only for the services used.</p>
                                                        <div id="card-element" ></div>
                                                        <div id="card-errors" role="alert"></div>
                                                        <span className="err_msg" id="ccDetailsErr" ></span>
                                                    </div>
                                                    <div className="inp_row clearfix">
                                                        <div className="inp_col_lhs">
                                                            <label>Billing Address</label>
                                                            <input type="text" ref={ this.billingAddressInput } name="billingAddress" id="billingAddress" value={ this.state.signupForm.billingAddress } onChange={ this.formChangeHandler } className="txt_box" />
                                                            <span className="err_msg" id="billingAddressErr" style={ { display: this.state.billingAddressEmpty ? 'inline-block' : 'none' } } >Billing Address cannot be blank</span>
                                                        </div>
                                                        <div className="inp_col_rhs">
                                                            <label>Zip Code</label>
                                                            <input type="text" ref={ this.zipCodeInput } name="zipCode" id="zipCode" value={ this.state.signupForm.zipCode } onChange={ this.formChangeHandler } className="txt_box" maxLength="20" />
                                                            <span className="err_msg" id="zipCodeErr" style={ { display: this.state.zipCodeEmpty ? 'inline-block' : 'none' } } >Zip Code cannot be blank</span>
                                                            <span className="err_msg" style={ { display: this.state.zipCodeRegex ? 'inline-block' : 'none' } }> Zip code can only contain characters A - Z, a - z, 0 - 9, -, _ and blank space </span>
                                                        </div>
                                                    </div>
                                                    <p className="form_note" style={ { display: "none" } }></p>
                                                    <div className="terms_wrap">
                                                        <input type="checkbox" name="isAgreed" value={ this.state.signupForm.isAgreed } onChange={ this.formChangeHandler } id="compute_terms" />
                                                        <label htmlFor="compute_terms">I agree to the <a href="https://www.idrivecompute.com/terms-and-conditions.htm" target="_blank">IDrive<sup>&reg;</sup> Compute terms</a> and acknowledge that I can receive emails on product updates from IDrive.</label>
                                                        <span className="err_msg" style={ { display: this.state.checkboxstatus ? 'inline-block' : 'none', fontSize: 15 } }>You must Agree the terms of IDrive<sup>&reg;</sup> Compute for account creation</span>
                                                    </div>
                                                    <ReCAPTCHA
                                                        sitekey="6LfMaG8aAAAAADtCmgI91y-9wbCjnaDTQwwIUv6-"
                                                        onChange={ (e) => this.onRecaptchaChange(e) }
                                                        ref={ this.recaptchaRef }
                                                        size="invisible"
                                                    />
                                                    <div className={ this.state.isAction ? "inp_btn_wrap loginSubmitLoader" : "inp_btn_wrap" }><input type="submit" name="" value={ this.state.isAction ? "" : "Create my account" } className="submit_btn" disabled={ !this.props.stripe } /> </div>
                                                </div>
                                            </div>
                                        </form>
                                    </section>
                                    <section className="signup_rhs">
                                        <div className="banner_sec">
                                            <h1>Secure virtual private server hosting for enterprise-grade edge computing</h1>
                                            <p className="title_txt" style={ { display: "none" } }>Quickly create virtual machines with desired configurations, manage and access them from any location.</p>
                                        </div>
                                        <div className="info_pointers">
                                            <ul>
                                                <li>
                                                    <figure className="icon_img flexiVirtualServer"></figure>
                                                    <div className="info_content_wrap">
                                                        <h4>Infrastructure as a Service</h4>
                                                        <p>Spin up multiple virtual instances using hardware and network infrastructure managed offsite and run your business.</p>
                                                    </div>
                                                </li>

                                                <li>
                                                    <figure className="icon_img customConfig"></figure>
                                                    <div className="info_content_wrap">
                                                        <h4>Custom configuration</h4>
                                                        <p>Choose from standard distributions or custom images to create instances; expand storage with high-speed volumes.</p>
                                                    </div>
                                                </li>

                                                <li>
                                                    <figure className="icon_img infraService"></figure>
                                                    <div className="info_content_wrap">
                                                        <h4>Edge computing</h4>
                                                        <p>A network of edge locations deployed in 20 locations and growing.</p>
                                                    </div>
                                                </li>

                                                <li style={ { display: "none" } }>
                                                    <figure className="icon_img clusterEdge"></figure>
                                                    <div className="info_content_wrap">
                                                        <h4>Clustered edge regions</h4>
                                                        <p>Enjoy low latency and network disruptions, faster performance with hyperscale network of edge location deployed.</p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </section>

                                </div>
                            </div>
                        </div>
                    </div>
                    <CommonMessage message={ this.state.message } handler={ () => this.setState({ message: '' }) }
                        msgType={ this.state.msgType } />

                </div>
                <Footer />
            </React.Fragment>
        );
    }
}

export default function InjectedCheckoutFormSignup() {

    return (
        <ElementsConsumer>
            { ({ stripe, elements }) => (
                <CheckoutFormSignup stripe={ stripe } elements={ elements } />
            ) }
        </ElementsConsumer>
    );
}

function asyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1500));
}